$(document).ready(function () {
  // money format code start here

  Shopify.money_format = "£{{amount}}";
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  //  console.log(Shopify.formatMoney(62160))

  // money format code end here

  $(".scrollTo").click(function (e) {
    let jump = $(this).attr("href");
    let new_position = $(jump).offset();
    let scroll = -20;
    $("html, body")
      .stop()
      .animate({ scrollTop: new_position.top + scroll }, 800, function () {
        let new_position = $(jump).offset();
        $("html, body")
          .stop()
          .animate({ scrollTop: new_position.top + scroll }, 800);
      });
    e.preventDefault();
  });

  // Menu open close Script Start Here
  $(document).on("click", ".js-hamburger-menu", function () {
    console.log("drawer open!!");
    $("body").toggleClass("open-menu");
    $("html").toggleClass("open-menu");
    $(this).toggleClass("active");
  });

  $(document).on("click", function (event) {
    let $trigger = $(".js-hamburger-menu, .eq-header__bottom");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
      // Bug-fix 14-May-2026: also strip `.open-menu` from <html>.
      // The hamburger click above adds the class to BOTH <body> and
      // <html> (so the scroll-lock CSS can target either), but this
      // outside-click handler used to only clean up <body>. Result:
      // tapping anywhere in the header (outside the menu drawer) to
      // dismiss the menu left <html> stuck with `.open-menu`, and
      // because the scroll-lock rule sits on `html.open-menu`, page
      // scrolling stayed disabled until the user explicitly tapped
      // the X. Mirror what the hamburger toggle does on open.
      $("body").removeClass("open-menu");
      $("html").removeClass("open-menu");
      $(".js-hamburger-menu").removeClass("active");
    }
  });
  // Menu open close Script End Here

  // USPA Slider Start Here
  if ($(".js-uspa-slider").length > 0) {
    $(".js-uspa-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 10.5L5.25 7L8.75 3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // USPA Slider Start Here

  // js-trusted-by-slider Start Here
  if ($(".js-trusted-by-slider").length > 0) {
    $(".js-trusted-by-slider").slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
            arrows: false,
          },
        },
      ],
    });
  }
  // js-trusted-by-slider Start Here

  // js-product-slider Start Here
  if ($(".js-product-slider").length > 0) {
    $(".js-product-slider").slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: true,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3.12,
          },
        },
      ],
    });
  }
  // js-product-slider Start Here

  // js-our-customers Start Here
  if ($(".js-our-customers").length > 0) {
    $(".js-our-customers").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: true,
      pauseOnHover: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
    });
  }
  // js-our-customers Start Here

  // js-as-featured-slider Start Here
  if ($(".js-as-featured-slider").length > 0) {
    $(".js-as-featured-slider").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
    });
  }
  // js-as-featured-slider Start Here

  // Case Studies Slider Start Here
  // 20-May-2026 redesign — Slick's built-in arrows are replaced by
  // the custom prev/next buttons rendered in the section header
  // (`.js-case-studies-prev` / `-next`). The slider's own arrows
  // are hidden via CSS so we get full styling control of the
  // header buttons. A live counter ("1 – 2 of N case studies")
  // also lives in the header and is updated on every slide change.
  if ($(".js-case-studies-slider").length > 0) {
    var $slider = $(".js-case-studies-slider");
    var $section = $slider.closest(".case-studies");
    var $prevBtn = $section.find(".js-case-studies-prev");
    var $nextBtn = $section.find(".js-case-studies-next");
    var $counterCurrent = $section.find("[data-cs-counter-current]");
    var $counterEnd     = $section.find("[data-cs-counter-end]");
    var totalCount = parseInt($section.attr("data-total-count"), 10) || 0;

    // Compute the highest "end" index visible at the current
    // breakpoint based on the section's data-slides-* attributes.
    // Returns 1-based end index (inclusive).
    function visibleEndIndex(currentSlide, slidesToShow) {
      var endIdx = currentSlide + slidesToShow;
      if (endIdx > totalCount) endIdx = totalCount;
      return endIdx;
    }

    // Update the "X – Y of N" counter text after each slide change.
    function updateCounter(slick) {
      if (!$counterCurrent.length || !slick) return;
      var slidesToShow = slick.options.slidesToShow || 1;
      var startIdx = (slick.currentSlide || 0) + 1;
      var endIdx   = visibleEndIndex(slick.currentSlide || 0, slidesToShow);
      $counterCurrent.text(startIdx);
      $counterEnd.text(endIdx);
    }

    $slider.on("init", function (event, slick) {
      updateCounter(slick);
    });
    $slider.on("afterChange", function (event, slick) {
      updateCounter(slick);
    });
    $slider.on("breakpoint", function (event, slick) {
      // Slick re-evaluates slidesToShow on viewport changes; resync
      // the counter so it reflects the new visible range.
      updateCounter(slick);
    });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // Wire up the custom header buttons to Slick's API. `slickPrev`
    // and `slickNext` advance the slider; Slick handles the
    // `slick-disabled` class on the buttons via the listeners we
    // bind below (since Slick's native prev/next aren't doing it).
    if ($prevBtn.length) {
      $prevBtn.on("click", function () { $slider.slick("slickPrev"); });
    }
    if ($nextBtn.length) {
      $nextBtn.on("click", function () { $slider.slick("slickNext"); });
    }

    // Reflect "can't go further" state on the header buttons. Slick
    // exposes `currentSlide` + total slides via the slick instance
    // attached to the element after init.
    function refreshDisabledState() {
      var slick = $slider.slick("getSlick");
      if (!slick) return;
      var slidesToShow = slick.options.slidesToShow || 1;
      var atStart = slick.currentSlide <= 0;
      var atEnd   = (slick.currentSlide + slidesToShow) >= totalCount;
      $prevBtn.toggleClass("slick-disabled", atStart).attr("aria-disabled", atStart);
      $nextBtn.toggleClass("slick-disabled", atEnd).attr("aria-disabled", atEnd);
    }
    $slider.on("afterChange init breakpoint", refreshDisabledState);
    // Initial state pass (slick already initialised before our
    // listeners attached in some scenarios — call once to be sure).
    refreshDisabledState();
  }
  // Case Studies Slider End Here

  // js-explore-more-topics-slider Start Here
  if ($(".js-explore-more-topics-slider").length > 0) {
    $(".js-explore-more-topics-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // js-explore-more-topics-slider End Here

  // js-other-completed-projects Start Here
  if ($(".js-other-completed-projects").length > 0) {
    $(".js-other-completed-projects").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // js-other-completed-projects End Here

  let trustedLogo = $(".trusted-logo__slider");
  if (trustedLogo.length > 0 && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  let jsTrustedBrandsSlider = $(".js-trusted-brands-slider");
  if (jsTrustedBrandsSlider.length > 0 && !jsTrustedBrandsSlider.hasClass("slick-initialized")) {
    jsTrustedBrandsSlider.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  if ($(".eq-expand-your-safety__content .box .text-desc").length > 0) {
    $(".eq-expand-your-safety__content .box .text-desc").matchHeight({
      byRow: true,
    });
  }
  if ($(".eq-expand-your-safety__content .box h4").length > 0) {
    $(".eq-expand-your-safety__content .box h4").matchHeight({
      byRow: true,
    });
  }
  if (
    $(".eq-our-bestsellers__content .box-main .box__desc .product-title")
      .length > 0
  ) {
    $(
      ".eq-our-bestsellers__content .box-main .box__desc .product-title"
    ).matchHeight({
      byRow: true,
    });
  }
  if (
    $(".eq-our-bestsellers__content .box-main .box__desc .text-desc").length > 0
  ) {
    $(
      ".eq-our-bestsellers__content .box-main .box__desc .text-desc"
    ).matchHeight({
      byRow: true,
    });
  }
  if ($(".eq-our-customers__content .box__desc .text-desc").length > 0) {
    $(".eq-our-customers__content .box__desc .text-desc").matchHeight({
      byRow: true,
    });
  }
  if ($(".explore-more-topics__box-desc h3").length > 0) {
    $(".explore-more-topics__box-desc h3").matchHeight({
      byRow: false,
    });
  }
  if ($(".explore-more-topics__box-desc .text-desc").length > 0) {
    $(".explore-more-topics__box-desc .text-desc").matchHeight({
      byRow: false,
    });
  }

  // Truncet on mobile text js start here
  if ($(".white-papper-article__index-list li a").length > 0) {
    $(".white-papper-article__index-list li a").Cuttr({
      truncate: "characters",
      length: 25,
    });
  }
  function applyCuttr() {
    if ($(window).width() <= 768) {
      if ($(".eq-expand-your-safety__content .box .text-desc").length > 0) {
        $(".eq-expand-your-safety__content .box .text-desc").Cuttr({
          truncate: "words",
          length: 10,
        });
      }
    }
  }
  applyCuttr();

  $(window).on("resize", function () {
    applyCuttr();
  });
  // Truncet on mobile text js end here

  // FAQ filter start here
  $(".js-accordian-title").click(function (j) {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .parents(".cus-accordian")
        .find(".cus-accordian__card")
        .removeClass("active");
      $(this).next().slideUp();
    } else {
      $(".js-accordian-title").removeClass("active");
      $(this)
        .parents(".cus-accordian")
        .find(".cus-accordian__card")
        .removeClass("active");
      $(".js-accordian-title").next().slideUp();
      $(this).addClass("active");
      $(this).parents(".cus-accordian__card").addClass("active");
      $(this)
        .next()
        .slideDown(function () {
          $(this).css("display", "block");
        });
    }
  });

  if ($(".eq-faq .eq-faq__filter-head").length > 0) {
    $(".eq-faq__filter-head button:first").addClass("active");
    let initialdataFilters = $(".js-filter-button").attr("data-filter");
    $(".cus-accordian__card").addClass("is-hidden");
    if (initialdataFilters == "general") {
      // $('.cus-accordian__card').removeClass('is-hidden');
      if ($('.cus-accordian__card[data-filter="general"]').length === 0) {
        $('.js-filter-button[data-filter="general"]').hide();
        // Activate the first available filter
        const nextFilterButton = $(".js-filter-button")
          .not('[data-filter="general"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $(
            '.cus-accordian__card[data-filter="' + nextFilter + '"]'
          ).removeClass("is-hidden");
        }
      } else {
        $('.cus-accordian__card[data-filter="general"]').removeClass(
          "is-hidden"
        );
      }
    }
  }
  $(window).on("load", function () {
    if ($(".eq-faq .eq-faq__filter-head").length > 0) {
      $(".eq-faq__filter-head button:first").click();
    }

    $(".customise-btn").on("click", function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "smooth");
    });
  });

  $(".js-filter-button").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");
    if (
      $('.cus-accordian__card[data-filter="' + dataFilter + '"]').length === 0
    ) {
      $(this).hide(); // Hide the button if no matching cards
    } else {
      $(".cus-accordian__card").addClass("is-hidden");
      $('.cus-accordian__card[data-filter="' + dataFilter + '"]').removeClass(
        "is-hidden"
      );
    }
  });
  // FAQ filter end here

  // Blog Filter js start here
  // if ($('.eq-blog-list__filter-head').length > 0) {
  //     let filterButtons = $('.js-blog-filter-button');
  //     let blogBoxes = $('.eq-blog-list__box');
  //     let dynamicBlogBoxes = $('.dynamic-posts');

  //     // Set initial active filter button
  //     filterButtons.removeClass('active');
  //     let initialFilter = filterButtons.first().attr('data-filter');
  //     filterButtons.first().addClass('active');

  //     // Hide all blog boxes initially
  //     blogBoxes.addClass('is-hidden');
  //     let initialFilterLatestPost = $(".eq-blog-list__box[data-filter='LatestPosts']");

  //     // Show only the initial filter's content
  //     if (initialFilter === initialFilterLatestPost) {
  //         initialFilterLatestPost.removeClass('is-hidden'); // Show all posts for 'LatestPosts'
  //         dynamicBlogBoxes.addClass('is-hidden'); // Hide all other post tabs
  //     } else {
  //         let initialContent = $('.eq-blog-list__box[data-filter="' + initialFilter + '"]');
  //         if (initialContent.length) {
  //             initialContent.removeClass('is-hidden');
  //         } else {
  //             filterButtons.first().hide(); // Hide button if no content exists
  //         }
  //     }
  // }

  // // Filter button click event
  // $('.js-blog-filter-button').on('click', function() {
  //     let thisButton = $(this);
  //     let dataFilter = thisButton.attr('data-filter');

  //     // Toggle active state
  //     thisButton.addClass('active').siblings().removeClass('active');

  //     // Hide all blog boxes and show only the selected one
  //     $('.eq-blog-list__box').addClass('is-hidden');

  //     if (dataFilter === "LatestPosts") {
  //         $('.eq-blog-list__box').removeClass('is-hidden'); // Show all posts
  //     } else {
  //         let filteredContent = $('.eq-blog-list__box[data-filter="' + dataFilter + '"]');
  //         if (filteredContent.length) {
  //             filteredContent.removeClass('is-hidden');
  //         } else {
  //             console.log("No content available for this category.");
  //         }
  //     }
  // });
  // Blog Filter js end here

  // Blog Filter js start here

  // On click filter buttons
  $(".js-blog-filter-button").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");

    // Hide all and show only the selected filter
    $(".eq-blog-list__box").addClass("is-hidden");
    $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').removeClass(
      "is-hidden"
    );

    // Hide button if no matching content
    if (
      $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length === 0
    ) {
      //    console.log("Filter Length : ", $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length);
      // $(this).hide();
    }

    let filterParent = $(
      '.eq-blog-list__box[data-filter="' + dataFilter + '"]'
    ).parent(".eq-blog-list__filter-content");
    if (!filterParent.hasClass("blog-filter-content-active")) {
      filterParent.addClass("blog-filter-content-active");
    }
    filterParent.siblings(".eq-blog-list__filter-content").each(function () {
      if ($(this).hasClass("blog-filter-content-active")) {
        $(this).removeClass("blog-filter-content-active");
      }
    });

    blogFilterDataMatchHeight();
  });
  // Blog Filter js end here

  if ($(window).width() < 991) {
    $(document).on("click", ".js-inner-title", function () {
      // Close all inner menus except the one being clicked
      $(".box-disc")
        .not($(this).parents(".box-disc"))
        .removeClass("active")
        .find(".inner-nav")
        .slideUp();

      // Toggle the clicked inner menu
      $(this).parents(".box-disc").toggleClass("active");
      $(this).parents(".box-disc").find(".inner-nav").slideToggle();
    });

    $(document).on("click", ".js-main-link", function () {
      // Close all main menus except the one being clicked
      $(".mega-menu-hover")
        .not($(this).parents(".mega-menu-hover"))
        .removeClass("active")
        .find(".mega-menu")
        .slideUp();

      // Toggle the clicked main menu
      $(this).parents(".mega-menu-hover").toggleClass("active");
      $(this).parents(".mega-menu-hover").find(".mega-menu").slideToggle();
    });
  }

  // Footer Accordian js start here
  function footerAddClassMobile() {
    if ($(window).width() <= 768) {
      console.log("test toggle");
      $(".eq-footer .eq-footer__nav-wrap:first").toggleClass("active");
      $(".eq-footer .eq-footer__nav-wrap:first")
        .find(".eq-footer__nav-list")
        .slideToggle();
    }
  }
  footerAddClassMobile();
  $(document).on("click", ".js-footer-nav-title", function () {
    // Close all inner menus except the one being clicked
    $(".eq-footer__nav-wrap")
      .not($(this).parents(".eq-footer__nav-wrap"))
      .removeClass("active")
      .find(".eq-footer__nav-list")
      .slideUp();

    // Toggle the clicked inner menu
    $(this).parents(".eq-footer__nav-wrap").toggleClass("active");
    $(this)
      .parents(".eq-footer__nav-wrap")
      .find(".eq-footer__nav-list")
      .slideToggle();
  });
  // Footer Accordian js end here
  $(document).on("click", ".view-more-swatch", function () {
    $(this).find(".main-product__swatch-text").text("Show Less");
    $(this).removeClass("view-more-swatch");
    $(this).addClass("view-less-swatch");
    $(this)
      .parents(".main-product__color-option")
      .find(".deafult-hidden-swatches")
      .show();
  });
  $(document).on("click", ".view-less-swatch", function () {
    $(this).find(".main-product__swatch-text").text("Show more");
    $(this).removeClass("view-less-swatch");
    $(this).addClass("view-more-swatch");
    $(this)
      .parents(".main-product__color-option")
      .find(".deafult-hidden-swatches")
      .hide();
  });

  /*
   $('.main-product__color-option input[type="radio"]').change(function() {
       console.log($('input[name="color-swatch"]:checked').val());
   });
   */

  $('input[name="width"]').on("input", function () {
   
    const inputValue = $(this).val();
    
    //    if (inputValue < 40) {
    //        $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message').show();
    //    } else {
    //        $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message').hide();
    //    }
    if (inputValue < 40) {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    }

    if (inputValue > 200) {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .hide();
    }

    if (inputValue === "") {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    }
  });

  $('input[name="length"]').on("input", function () {
    const inputValue = $(this).val();
    if (inputValue > 700) {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .show();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    }

    if (inputValue < 40) {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .show();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .hide();
    }

    if (inputValue === "") {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message-length--required")
        .show();
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .hide();
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message-length--required")
        .hide();
    }
  });

  /* Current VAT mode, from fm-vat.js's single source of truth. Falls back to
     ex so a failure to load fm-vat.js can never inflate a displayed price. */
  function fm150VatMode() {
    var attr = document.documentElement.getAttribute("data-vat-mode");
    if (attr === "inc" || attr === "ex") return attr;
    return window.fmVatMode === "inc" ? "inc" : "ex";
  }

  /* Made-to-measure total.
     --------------------------------------------------------------------
     VAT-aware since 03-Aug-2026. Previously this priced the line from
     `data-price_product`, which Liquid bakes from the `incl_vat` querystring
     at render time — but the VAT mode ALSO persists in sessionStorage with no
     reload. So a shopper who chose Inc. VAT elsewhere and then opened this
     page on a plain URL saw the EX-VAT total sitting under an "(Inc. VAT)"
     label: £124.50 where £149.40 was due, 20% light, all the way to the
     surprise at checkout.

     VAT is applied to the line TOTAL, not per unit, so there is no per-unit
     rounding drift: totalInc = round(totalEx x 1.2).

     #product-price's data-ex-price / data-inc-price are rewritten to the two
     TOTALS here, so if the mode is flipped afterwards fm-vat.js swaps between
     real totals instead of reverting the heading to the unit rate. The
     original unit values are stashed once on first use so the reset path can
     put them back. */
  function fm150StashUnitPrices($hero) {
    if ($hero.attr("data-unit-ex-price") === undefined) {
      $hero.attr("data-unit-ex-price", $hero.attr("data-ex-price") || "");
      $hero.attr("data-unit-inc-price", $hero.attr("data-inc-price") || "");
    }
  }

  function qty_cal_150(_this) {
    var $scope = _this.closest(".product-calculations-150max");
    var $main = _this.closest(".main-product");
    var $priceCal = $scope.find(".pric_cal");
    var $hero = $main.find("#product-price");

    var widthRaw = $scope.find("input.width_cal_150").val();
    var lengthRaw = $scope.find("input.length_cal_150").val();
    var width = Number(widthRaw);
    var length = Number(lengthRaw);

    /* Units are 10x10cm blocks — the rate is per 100cm², not per cm². */
    var units = Math.ceil((width * length) / 100);

    $scope.find("#quantity").val(units).attr("value", units);

    fm150StashUnitPrices($hero);

    /* Reset first; the priced branch below overwrites when it applies. */
    $priceCal.html("").removeAttr("data-total-ex");
    $hero
      .attr("data-ex-price", $hero.attr("data-unit-ex-price"))
      .attr("data-inc-price", $hero.attr("data-unit-inc-price"));
    $hero.html(
      fm150VatMode() === "inc"
        ? $hero.attr("data-unit-inc-price")
        : $hero.attr("data-unit-ex-price")
    );

    if (widthRaw === "" || lengthRaw === "") return;
    if (!isFinite(units) || units <= 0) return;

    var mf = $priceCal.attr("data-money_for");
    /* Prefer the explicit ex-VAT unit price; `data-price_product` is the
       legacy attribute and varies with the incl_vat querystring. */
    var unitEx = Number(
      $priceCal.attr("data-unit-ex") || $priceCal.attr("data-price_product")
    );
    if (!isFinite(unitEx)) return;

    var totalEx = units * unitEx;
    var totalInc = Math.round(totalEx * 1.2);

    var exFormatted = Shopify.formatMoney(totalEx, mf);
    var incFormatted = Shopify.formatMoney(totalInc, mf);
    var shown = fm150VatMode() === "inc" ? incFormatted : exFormatted;

    /* `data-total-ex` is read by the mobile buybar for its CTA, which is always
       ex VAT whatever the page's display mode — the sitewide rule is that the
       headline flips with the VAT toggle but the cart button does not. Stashed
       here so the buybar never has to re-derive the maths. */
    $priceCal.html(shown).attr("data-total-ex", exFormatted);
    $hero
      .attr("data-ex-price", exFormatted)
      .attr("data-inc-price", incFormatted)
      .html(shown);
    $main.find(".hide_price_text").hide();
  }

  /* Re-price when the shopper flips the VAT toggle. fm-vat.js has already
     swapped #product-price by then (from the data attributes written above),
     but `.pric_cal` is ours to keep in step. */
  $(document).on("fm:vat-changed", function () {
    var $anyDim = $("input.width_cal_150").first();
    if ($anyDim.length) qty_cal_150($anyDim);
  });

  /* Is one made-to-measure dimension field within its own min/max?
     Empty counts as invalid — a blank field must never enable ordering. */
  function fm150DimValid($field) {
    if (!$field.length) return false;
    var raw = $.trim($field.val());
    if (raw === "") return false;
    var value = Number(raw);
    if (isNaN(value)) return false;
    var min = parseInt($field.attr("min"), 10);
    var max = parseInt($field.attr("max"), 10);
    if (!isNaN(min) && value < min) return false;
    if (!isNaN(max) && value > max) return false;
    return true;
  }

  /* Made-to-measure width / length validation.
     --------------------------------------------------------------------
     Rewritten 03-Aug-2026. The previous version tested ONLY the field that
     had just fired, and its else-branch re-enabled Add to Basket whenever
     both fields were merely NON-EMPTY — it never re-checked the other
     field's range. So the guard could be walked straight past by entering
     the bad value first and a good one second:

         width 1    -> correctly disabled, "between 50cm and 150cm" shown
         length 150 -> length is fine and both are filled, so ENABLED,
                       with the width error still on screen

     That put a 1cm-wide mat in the basket at £1.66 (`_fm_qty_mode: unit`,
     priced by the transform app at ceil(1x150/100) = 2 units). The max side
     had the same hole: width 200 then length 150 was orderable. Both are the
     "customers ordering 1cm" class of fault.

     Now every input event revalidates BOTH fields, and Add to Basket is
     enabled only when each one is individually in range. Each field still
     owns its own message, so correcting the length no longer clears a
     width error that is still true. */
  /* Tracks whether the pair was already valid on the previous keystroke, so
     `fm:dimensions-complete` fires on the TRANSITION into a priced state
     rather than on every subsequent keystroke that happens to stay valid.
     Deliberately outside the handler — it is per-page state, and there is only
     ever one dimensions block on a page. */
  var fm150WasValid = false;

  $("input.width_cal_150, input.length_cal_150").on("input", function () {
    var $scope = $(this).closest(".product-calculations-150max");
    var $main = $(this).closest(".main-product");
    var $width = $scope.find("input.width_cal_150");
    var $length = $scope.find("input.length_cal_150");

    /* Show a field's message only once it has been filled in — an untouched
       empty field shouldn't shout at someone part-way through entry. */
    $.each([$width, $length], function (_, $field) {
      var filled = $.trim($field.val()) !== "";
      $field
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .toggle(filled && !fm150DimValid($field));
    });

    var bothValid = fm150DimValid($width) && fm150DimValid($length);

    if (bothValid) {
      $scope.find(".custom-atc-basket").removeAttr("disabled");
      /* qty_cal_150 writes #quantity, .pric_cal and the hero price, and
         hides the "From just" / per-unit spans. */
      qty_cal_150($(this));
    } else {
      $scope.find(".custom-atc-basket").attr("disabled", "disabled");
      /* Reset to the unpriced state rather than leave a total sitting under
         a visible error. Mirrors qty_cal_150's own reset path, including
         restoring #product-price from data-price.

         `data-total-ex` must be dropped here too, not just in qty_cal_150 —
         this branch doesn't call it. The mobile buybar treats the presence of
         that attribute as "a valid size is priced", so a stale one left behind
         would keep the footer in its selected state after the size went out of
         range. */
      $scope.find(".pric_cal").html("").removeAttr("data-total-ex");
      $scope.find("#quantity").val(1).attr("value", 1);
      $main.find(".hide_price_text").show();
      $main
        .find("#product-price")
        .html($main.find("#product-price").attr("data-price"));
    }

    /* Two events, deliberately, because two consumers need different things.

       `fm:dimensions-state` — EVERY input, carrying the full state. The mobile
       buybar (fm-buybar-mtm.js) needs continuous state so it can fall back to
       the slim prompt the moment a size stops being valid, not just advance
       when it starts being.

       `fm:dimensions-complete` — the TRANSITION into a priced state only. The
       modal's scroll-into-view uses this, so it fires once when the total
       appears rather than on every keystroke that keeps it valid.

       Both are emitted only from this user-input handler, so a VAT re-price
       (which also calls qty_cal_150) can never move the footer or the scroll
       position. */
    document.dispatchEvent(
      new CustomEvent("fm:dimensions-state", {
        detail: {
          valid: bothValid,
          width: $width.val(),
          length: $length.val(),
          totalEx: bothValid ? $scope.find(".pric_cal").attr("data-total-ex") || "" : ""
        }
      })
    );

    if (bothValid && !fm150WasValid) {
      document.dispatchEvent(
        new CustomEvent("fm:dimensions-complete", {
          detail: { width: $width.val(), length: $length.val() }
        })
      );
    }
    fm150WasValid = bothValid;
  });

  $(document).on("click", ".main-product__button", function () {
    const fileInput = document.querySelector(
      ".main-product__upload-file-input"
    );
    const file = fileInput.files[0];

    // Remove the file requirement check - logo is now optional
    // if (!file) {
    //   alert("Please select a file to upload.");
    //   return;
    // }
    
    var isValid = true;
    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    
    if (
      (selected_size_dropdown && selected_size_dropdown.includes("custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("Custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("CUSTOM"))
    ) {
      let minWidthValue = 40;
      let maxWidthValue = 200;
      let width_val = parseFloat($('input[name="width"]').val());
      console.log("Width Value : ");
      if (width_val < minWidthValue || isNaN(width_val)) {
        isValid = false;
        $('input[name="width"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message")
          .show();
      }
      if (width_val > maxWidthValue ) {
        isValid = false;
        $('input[name="width"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message--max")
          .show();
      } 
      let minLengthValue = 700;
      let length_val = parseFloat($('input[name="length"]').val());
      if (length_val > minLengthValue || isNaN(length_val)) {
        $('input[name="length"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message")
          .show();
        isValid = false;
      }
    }

    if (isValid) {
      Fancybox.show([
        {
          src: "#secure-checkout",
          type: "inline",
        },
      ]);
    }
  });

  // lozad js
  const observer = lozad(); // lazy loads elements with default selector as ".lozad"
  observer.observe();

  // collection product card Js

  if ($(".product-grid .card .card__information .card__heading").length > 0) {
    $(".product-grid .card .card__information .card__heading").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".product-grid .card .card__information .product-attribute").length > 0
  ) {
    $(".product-grid .card .card__information .product-attribute").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".product-grid .card .card__information .card-information > .price")
      .length > 0
  ) {
    $(
      ".product-grid .card .card__information .card-information > .price"
    ).matchHeight({
      byRow: true,
    });
  }

  /*
   if($('.eq-blog-list__box-desc h2').length > 0){
       $('.eq-blog-list__box-desc h2').matchHeight({
           byRow: true,
       });        
   }

   if($('.eq-blog-list__box-desc .text-desc').length > 0){
       $('.eq-blog-list__box-desc .text-desc').matchHeight({
           byRow: true,
       });        
   }
   */

  // Function to handle file upload and preview
  let fileInput = document.querySelector(".main-product__upload-file-input");

  /* iOS stuck-picker rescue (25-Aug-2026). If the phone locks while the
     photo picker sheet is up, iOS tears the picker down without telling
     Safari, and the TAB then silently ignores every later file-input
     activation — surviving page reloads — until the tab is closed. Nothing
     page-side can un-stick that, so instead: detect a tap that produced no
     picker (no window blur / visibility loss and no change/cancel inside the
     watch window), quietly swap in a fresh input node on the first dead tap
     (rescues milder variants), and from the second dead tap reveal the
     `.lm-upload-rescue` note in main-product.liquid — offering an
     email-it-later skip that needs no picker. A tap
     whose picker DID open never trips this: presenting the picker blurs the
     window, and dismissing it without a choice fires `cancel`. */
  const logoPickerWatch = { failures: 0, timer: null, opened: false };

  function logoPickerOpened() {
    logoPickerWatch.opened = true;
  }
  window.addEventListener("blur", logoPickerOpened);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") logoPickerOpened();
  });

  /* Called on any proof the picker works (change/cancel event, or a watched
     tap that blurred the window): stand down and hide the rescue note. */
  function logoPickerRecovered() {
    logoPickerWatch.opened = true;
    logoPickerWatch.failures = 0;
    clearTimeout(logoPickerWatch.timer);
    const rescue = document.querySelector(".lm-upload-rescue");
    if (rescue) rescue.hidden = true;
  }

  function replaceLogoInputNode() {
    const staleInput = document.querySelector(
      ".main-product__upload-file-input"
    );
    if (!staleInput) return;
    /* The stale node keeps its direct listeners, so if this swap ever runs
       while a picker is genuinely open (a missed open signal), the file the
       customer picks still lands on the old node and still uploads. */
    const freshInput = staleInput.cloneNode(false);
    bindLogoUploadInput(freshInput);
    staleInput.replaceWith(freshInput);
  }

  function showLogoUploadRescue() {
    const rescue = document.querySelector(".lm-upload-rescue");
    if (!rescue) return;
    rescue.hidden = false;
    if (typeof rescue.scrollIntoView === "function") {
      rescue.scrollIntoView({ block: "nearest" });
    }
  }

  function watchLogoPickerTap() {
    logoPickerWatch.opened = false;
    clearTimeout(logoPickerWatch.timer);
    logoPickerWatch.timer = setTimeout(function () {
      if (logoPickerWatch.opened) {
        logoPickerRecovered();
        return;
      }
      logoPickerWatch.failures++;
      replaceLogoInputNode();
      if (logoPickerWatch.failures >= 2) showLogoUploadRescue();
    }, 1500);
  }

  /* Logo brightness (23-Sep-2026, Jack): the wizard no longer asks for a
     background colour, so the default has to suit the logo — a dark logo on
     the default black mat would show the customer a black proof. Read the
     LOCAL file (the proof server's copy has no CORS headers, so its pixels
     can't be sampled), scale to ≤64px, and average the luminance of the
     opaque pixels. Announced on `document` as `lmw:logo-brightness`
     ({luminance 0–1, coverage 0–1} or null for PDFs/unreadable files);
     eq-product-script.js picks the swatch. */
  function analyseLogoBrightness(file) {
    return new Promise(function (resolve) {
      if (!file || !/^image\//.test(file.type || "")) return resolve(null);
      let url;
      try {
        url = URL.createObjectURL(file);
      } catch (e) {
        return resolve(null);
      }
      const img = new Image();
      const finish = function (value) {
        try { URL.revokeObjectURL(url); } catch (e) {}
        resolve(value);
      };
      img.onload = function () {
        try {
          const naturalW = img.naturalWidth || 1;
          const naturalH = img.naturalHeight || 1;
          const scale = Math.min(1, 64 / Math.max(naturalW, naturalH));
          const w = Math.max(1, Math.round(naturalW * scale));
          const h = Math.max(1, Math.round(naturalH * scale));
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);
          const data = ctx.getImageData(0, 0, w, h).data;
          let sum = 0;
          let opaque = 0;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 128) continue;
            sum += (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]) / 255;
            opaque++;
          }
          finish(opaque ? { luminance: sum / opaque, coverage: opaque / (w * h) } : null);
        } catch (e) {
          finish(null);
        }
      };
      img.onerror = function () { finish(null); };
      img.src = url;
    });
  }

  function announceLogoBrightness(info) {
    try {
      document.dispatchEvent(new CustomEvent("lmw:logo-brightness", { detail: info || null }));
    } catch (e) {}
  }

  function bindLogoUploadInput(node) {
    node.addEventListener("change", handleLogoFileChange);
    node.addEventListener("cancel", logoPickerRecovered);
    node.addEventListener("click", watchLogoPickerTap);
  }

  /* EPS (Illustrator and most designers' exports) and PSD (Photoshop). Some browsers give these
     files no type, so the name decides too. */
  function isDesignLogoFile(file) {
    const type = String((file && file.type) || "").toLowerCase();
    return /\.(eps|epsf|ps|psd)$/i.test(String((file && file.name) || "")) || /postscript|eps|photoshop|psd/.test(type);
  }

  /* What the proof can read: any picture or a PDF. Either the type or the name will do, as some
     systems give a picture no type (HEIC) or a generic one. */
  function isLogoPictureOrPdf(file) {
    const type = String((file && file.type) || "").toLowerCase();
    return type.indexOf("image/") === 0 || type === "application/pdf" || /\.(png|jpe?g|gif|bmp|webp|tiff?|heic|heif|svg|pdf)$/i.test(String((file && file.name) || ""));
  }

  async function handleLogoFileChange(event) {
    const input = event.target;
    logoPickerRecovered();
    console.log("File added:", input);
    let file = input.files[0];
    if (!file) return; // Check if a file was selected
    /* The format the customer chose, shown on the badge: an EPS is uploaded as the PDF it is
       converted to, and a "PDF" badge read as the wrong file (Jack, 13-Oct-2026). */
    const chosenFormat = isDesignLogoFile(file) && !/\.psd$/i.test(file.name || "") && !/photoshop|psd/i.test(file.type || "") ? "EPS" : "PDF";

      console.log("Selected file:", file);

      // Uploading state: message + spinner while the file is in flight
      const uploadOption = document.querySelector(".main-product__upload-option");
      const statusMessage = document.getElementById("statusMessage");
      if (uploadOption) uploadOption.classList.add("is-uploading");
      if (uploadOption) uploadOption.classList.remove("is-error");
      if (statusMessage) {
        statusMessage.textContent = "Uploading your logo…";
        statusMessage.classList.add("is-uploading");
        statusMessage.classList.remove("is-error");
      }

      /* An EPS or PSD (Jack, 13-Oct-2026): a designer's file, converted in the customer's browser
         by the proof page's own converter before it is uploaded -- an EPS becomes a PDF, a PSD a
         PNG -- so the upload and the proof take it as they take any PDF or picture. */
      if (isDesignLogoFile(file)) {
        if (statusMessage) statusMessage.textContent = /\.psd$/i.test(file.name || "") ? "Reading your Photoshop file…" : "Reading your EPS file…";
        try {
          let converter;
          try {
            converter = await import("https://design.firstmats.co.uk/assets/design-files.js");
          } catch (loadError) {
            throw new Error("We couldn't open that file type just now. Please save it as a PNG or PDF and try again.");
          }
          file = await converter.designFileAsUpload(file);
        } catch (convertError) {
          if (uploadOption) uploadOption.classList.remove("is-uploading");
          if (uploadOption) uploadOption.classList.add("is-error");
          if (statusMessage) {
            statusMessage.textContent = (convertError && convertError.message) || "That file couldn't be read. Please save it as a PNG or PDF and try again.";
            statusMessage.classList.remove("is-uploading");
            statusMessage.classList.add("is-error");
          }
          input.value = "";
          return;
        }
        if (statusMessage) statusMessage.textContent = "Uploading your logo…";
      }

      /* Only a picture or a PDF goes up (BUG-47, 25-Oct-2026): the file picker's "All files" and a
         drop both get past `accept`, and a Word .docx went to the proof, which can't read it. */
      if (!isLogoPictureOrPdf(file)) {
        if (uploadOption) uploadOption.classList.remove("is-uploading");
        if (uploadOption) uploadOption.classList.add("is-error");
        if (statusMessage) {
          statusMessage.textContent = "That file couldn't be read. Please save it as a PNG or PDF and try again.";
          statusMessage.classList.remove("is-uploading");
          statusMessage.classList.add("is-error");
        }
        input.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(
          "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/imgupload.php",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          const result = await response.json();
          console.log("Upload response:", result);

          if (result.fileUrl) {
            // Store the file URL in hidden input for later use
            document.querySelector(".main-product__uploaded-file-url").value = result.fileUrl;
            
            // Check if file is PDF or image
            const isPDF = file.type === 'application/pdf';
            
            if (isPDF) {
              // Display PDF icon/name instead of preview
              // PDF: a plain "PDF" badge — no file name (v3 design, 23-Sep-2026); "EPS" for an EPS.
              // A PSD becomes a picture, so it shows as one.
              document.querySelector(
                ".main-product__upload-preview"
              ).innerHTML = `
                <div class="lmw-upload__pdf"><span class="lmw-upload__pdf-badge">${chosenFormat}</span></div>
              `;
            } else {
              // Display the uploaded image preview
              document.querySelector(
                ".main-product__upload-preview"
              ).innerHTML = `<img src="${result.fileUrl}" alt="Uploaded Image">`;
            }

            // Update status and UI. `has-logo` on the upload option switches
            // the dropzone into its uploaded state (CSS hides the prompt and
            // file-format copy so only the logo and the remove control show).
            document.getElementById("statusMessage").textContent =
              "Logo uploaded";
            document.querySelector(".main-product__upload-icon").style.display =
              "none";
            document.querySelector(
              ".main-product__upload-remove"
            ).style.display = "block";
            if (uploadOption) uploadOption.classList.add("has-logo");
            if (uploadOption) uploadOption.classList.remove("is-error");

            // Pick a background colour that suits this logo (see analyseLogoBrightness).
            analyseLogoBrightness(file).then(announceLogoBrightness);

            // Logo Source for Dataverse (read by eq-product-script.js at
            // submission). A real upload always wins over a deferred flag.
            const logoSource = document.querySelector(".main-product__uploaded-logo-source");
            if (logoSource) logoSource.value = "upload";
          } else {
            document.getElementById("statusMessage").textContent =
              "Failed to retrieve the file URL.";
            if (statusMessage) statusMessage.classList.add("is-error");
          }
        } else {
          document.getElementById("statusMessage").textContent =
            "File upload failed.";
          if (statusMessage) statusMessage.classList.add("is-error");
        }
      } catch (error) {
        console.error("Error:", error);
        document.getElementById("statusMessage").textContent =
          "An error occurred during file upload.";
        if (statusMessage) statusMessage.classList.add("is-error");
      } finally {
        if (uploadOption) uploadOption.classList.remove("is-uploading");
        if (statusMessage) statusMessage.classList.remove("is-uploading");
      }
  }

  if (fileInput) {
    bindLogoUploadInput(fileInput);
  }

  // Function to handle image removal
  let fileUploadRemove = document.querySelector(".main-product__upload-remove");
  if (fileUploadRemove) {
    fileUploadRemove.addEventListener("click", function () {
      // Clear the preview and reset the UI
      document.querySelector(".main-product__upload-preview").innerHTML = "";
      document.getElementById("statusMessage").textContent = "";
      document.querySelector(".main-product__upload-icon").style.display = "block";
      document.querySelector(".main-product__upload-remove").style.display = "none";

      // Reset the file input value to allow re-selection of the same file
      document.querySelector(".main-product__upload-file-input").value = "";

      // Clear the stored file URL
      document.querySelector(".main-product__uploaded-file-url").value = "";

      // Back to the empty dropzone state
      const uploadOption = document.querySelector(".main-product__upload-option");
      if (uploadOption) uploadOption.classList.remove("has-logo");
      announceLogoBrightness(null); // no logo → default background again

      // Logo Source: nothing uploaded any more. If the stuck-picker rescue
      // deferred the logo to email earlier, that is still the truth.
      const logoSource = document.querySelector(".main-product__uploaded-logo-source");
      const logoDeferred = document.querySelector(".main-product__logo-deferred");
      if (logoSource) {
        logoSource.value =
          logoDeferred && (logoDeferred.value || "").trim() === "1" ? "email-later" : "";
      }

      // Clear the lingering status message
      const removedStatus = document.getElementById("statusMessage");
      if (removedStatus) {
        removedStatus.textContent = "";
        removedStatus.classList.remove("is-uploading", "is-error");
      }
    });
  }

  if ($(".case-studies__slider .case-studies__box-content h3").length > 0) {
    $(".case-studies__slider .case-studies__box-content h3").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".case-studies__slider .case-studies__box-content .text-desc").length > 0
  ) {
    $(
      ".case-studies__slider .case-studies__box-content .text-desc"
    ).matchHeight({
      byRow: true,
    });
  }


  /* Customer review slider JS Start */

  let customerReviewSlider = $('.js-customer-review-slider');

  if(customerReviewSlider.length > 0 ){
    customerReviewSlider.each(function () {
      let currentCustomerReviewSlider = $(this);

      if (!currentCustomerReviewSlider.hasClass('slick-initialized')) {
        currentCustomerReviewSlider.slick({
          arrows: false,
          infinite: true,
          loop: true,
          slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-desktop'), 10),
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          draggable: true,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-tab'), 10),
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-mobile'), 10),
              }
            }
          ]
      });
      }

    });
  }

/* =========================================================================
 *  Mobile-only "bold-headline-only" treatment for the rich-text metafield
 *  --------------------------------------------------------------------
 *  The PDP `metafield-rich_text_field` is a list whose items follow the
 *  pattern `<li><strong>HEADLINE</strong> — supporting copy</li>`. On
 *  mobile we want only the bold headline visible (the supporting copy
 *  is too long for a phone reading pattern); on desktop both stay.
 *
 *  Approach: walk each `<li>`, find the LAST `<strong>` child, and wrap
 *  every node that comes AFTER it in a `<span class="…__detail">`. CSS
 *  in eq-product-style.css hides that span at ≤767px. The full text
 *  stays in the DOM either way so search engines see the complete
 *  bullet content and screen readers can opt to read both.
 *
 *  Idempotency: skips items that already carry a `__detail` wrapper —
 *  safe to call multiple times if the metafield re-renders via AJAX
 *  (e.g. variant change).
 * ========================================================================= */
(function () {
  'use strict';
  function wrapDetails(li) {
    if (!li || li.querySelector(':scope > .metafield-rich_text_field__detail')) return;

    /* Find the last <strong> child — handles items with multiple
       bold spans (e.g. "<strong>Headline</strong> — copy
       <strong>more</strong> trailing"). The wrap starts after the
       LAST strong so trailing standalone bolds are preserved as
       headline. */
    var children = li.childNodes;
    var lastStrongIdx = -1;
    for (var i = 0; i < children.length; i++) {
      var n = children[i];
      if (n.nodeType === 1 && n.tagName === 'STRONG') lastStrongIdx = i;
    }
    if (lastStrongIdx < 0) return;

    /* Collect everything after the last strong; bail if there's nothing
       to wrap (item is bold-only, no supporting copy). */
    var toWrap = [];
    for (var j = lastStrongIdx + 1; j < children.length; j++) toWrap.push(children[j]);
    if (!toWrap.length) return;

    var span = document.createElement('span');
    span.className = 'metafield-rich_text_field__detail';
    /* Move nodes into the span first, then insert the span at the
       collected-from position. Inserting first then moving children
       would invalidate the live `children` NodeList mid-loop. */
    toWrap.forEach(function (node) { span.appendChild(node); });
    li.appendChild(span);
  }

  function run() {
    document.querySelectorAll('.metafield-rich_text_field li').forEach(wrapDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


  /* Customer review slider JS End */

});

function blogFilterDataMatchHeight() {
  let blogListFilters = [];

  if ($(".eq-blog-list__box").length > 0) {
    $(".eq-blog-list__box").each(function () {
      let filterValue = $(this).data("filter");
      // console.log('filterValue : ', filterValue);;

      if (!blogListFilters.includes(filterValue)) {
        //    console.log(`blogListFilters : ${blogListFilters} - filterValue : ${filterValue}`);
        blogListFilters.push(filterValue);
        //    console.log(`blogListFilters : ${blogListFilters}`);
      }
    });
  }

  if (blogListFilters) {
    blogListFilters.forEach(function (filter) {
      //  console.log("filter : ", filter);

      let filterBoxes = $(
        '.eq-blog-list__box[data-filter="' +
          filter +
          '"] .eq-blog-list__box-desc'
      );

      //  console.log(`class check ${$('.eq-blog-list__filter-content').first().attr('class')}`);
      //  console.log(`child length ${$('.eq-blog-list__filter-content').first().find('.eq-blog-list__box[data-filter="' + filter + '"]')}`);

      if (filterBoxes.find("h2").length > 0) {
        filterBoxes.find("h2").matchHeight({
          byRow: true,
        });
      }

      if (filterBoxes.find(".text-desc").length > 0) {
        filterBoxes.find(".text-desc").matchHeight({
          byRow: true,
        });
      }
    });
  }
}

$(window).on("load", function () {
  if ($(".eq-blog-list__filter-head").length > 0) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("data-filter")) {
      let filterValue = urlParams.get("data-filter");
      $(".eq-blog-list__box").addClass("is-hidden");
      let queryParameterFilter = $(
        `.eq-blog-list__filter-button[data-filter="${filterValue}"]`
      );
      console.log("queryParameterFilter : ", queryParameterFilter);
      queryParameterFilter.trigger("click");
    } else {
      $(".eq-blog-list__filter-head button:first").addClass("active");

      // Hide all blog list items initially
      $(".eq-blog-list__box").addClass("is-hidden");

      // Show only elements with data-filter="LatestPosts" on the first load
      let latestPosts = $('.eq-blog-list__box[data-filter="LatestPosts"]');

      if (latestPosts.parent().hasClass("eq-blog-list__filter-content")) {
        latestPosts.parent().addClass("blog-filter-content-active");
      }

      if (latestPosts.length > 0) {
        latestPosts.removeClass("is-hidden");
      } else {
        // If "LatestPosts" is not available, show the first available filter
        const nextFilterButton = $(".js-blog-filter-button")
          .not('[data-filter="LatestPosts"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $('.eq-blog-list__box[data-filter="' + nextFilter + '"]').removeClass(
            "is-hidden"
          );
        }
      }

      console.log("load");

      blogFilterDataMatchHeight();
    }
  }
  



  if ($(".eq-blog-gallery__filter-head").length > 0) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("data-filter")) {
      let filterValue = urlParams.get("data-filter");
      $(".eq-blog-list__box").addClass("is-hidden");
      let queryParameterFilter = $(
        `.eq-blog-list__filter-button[data-filter="${filterValue}"]`
      );
      console.log("queryParameterFilter : ", queryParameterFilter);
      queryParameterFilter.trigger("click");
    } else {
      $(".eq-blog-gallery__filter-head button:first").addClass("active");

      // Hide all blog list items initially
      $(".eq-blog-list__box").addClass("is-hidden");

      // Show only elements with data-filter="LatestPosts" on the first load
      let latestPosts = $('.eq-blog-list__box[data-filter="LatestPosts"]');

      if (latestPosts.parent().hasClass("eq-blog-list__filter-content")) {
        latestPosts.parent().addClass("blog-filter-content-active");
      }

      if (latestPosts.length > 0) {
        latestPosts.removeClass("is-hidden");
      } else {
        // If "LatestPosts" is not available, show the first available filter
        const nextFilterButton = $(".js-gallery-filter-button")
          .not('[data-filter="LatestPosts"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $('.eq-blog-list__box[data-filter="' + nextFilter + '"]').removeClass(
            "is-hidden"
          );
        }
      }

      console.log("load");

      galleryBlogFilterDataMatchHeight();
    }
  }
});

function scrollToElement(element) {
  if (element) {
    // Get the position of the element relative to the document (top position)
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    // Calculate the desired scroll position with the offset (100px from the top)
    const offsetPosition = elementPosition - 100; // 100px above the top
    // Scroll smoothly to the calculated position
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
}

let blogFilterHeader = document.querySelector(".eq-blog-list__filter-head");
scrollToElement(blogFilterHeader);

let siteLoader = $(".eq-blog-list__loader");

function loadPaginatedContent(event, pageUrl, activeFilter) {
  event.preventDefault();

  if (
    !siteLoader.hasClass("is-active-loader") &&
    !$("body").hasClass("is-active-loader")
  ) {
    siteLoader.addClass("is-active-loader");
    $("body").addClass("is-active-loader");
  }

  fetch(pageUrl)
    .then((response) => response.text())
    .then((html) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");

      // Find the updated blog posts for the selected category
      let newContent = doc.querySelector(
        `.eq-blog-list__filter-content [data-filter='${activeFilter}']`
      ).parentElement.innerHTML;

      console.log(newContent);

      // Find new pagination for the active tab
      let newPagination = doc.querySelector(
        `.pagination[data-filter='${activeFilter}']`
      );

      // Replace only the content of the active tab
      document.querySelector(
        `.eq-blog-list__filter-content [data-filter='${activeFilter}']`
      ).parentElement.innerHTML = newContent;

      // Update pagination controls
      if (newPagination) {
        document.querySelector(
          `.pagination[data-filter='${activeFilter}']`
        ).innerHTML = newPagination.innerHTML;
      }

      blogFilterDataMatchHeight();

      // Hide all blog list items initially
      $(".eq-blog-list .eq-blog-list__box").addClass("is-hidden");

      let currentUrlActiveFilter = $(
        `.eq-blog-list__filter-button[data-filter="${activeFilter}"]`
      );

      currentUrlActiveFilter.trigger("click");

      if (
        siteLoader.hasClass("is-active-loader") &&
        $("body").hasClass("is-active-loader")
      ) {
        siteLoader.removeClass("is-active-loader");
        $("body").removeClass("is-active-loader");
      }

      let blogFilterHeader = document.querySelector(
        ".eq-blog-list__filter-head"
      );
      let galleryListHeader = document.querySelector(".gallery-list");
      if (blogFilterHeader) {
        scrollToElement(blogFilterHeader);
      }
      if (galleryListHeader) {
        scrollToElement(galleryListHeader);
      }
    })
    .catch((error) => {
      console.error("Error loading pagination:", error);
      if (
        siteLoader.hasClass("is-active-loader") &&
        $("body").hasClass("is-active-loader")
      ) {
        siteLoader.removeClass("is-active-loader");
        $("body").removeClass("is-active-loader");
      }
    });
}

$(document).ready(function () {
  // USPA lp Slider Start Here
  if ($(".js-lp-uspa-slider").length > 0) {
    $(".js-lp-uspa-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.75 7.5L1.25 4L4.75 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 7.5L4.75 4L1.25 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // USPA lp Slider Start Here

  // UGC lp Slider Start Here
  if ($(".js-ugc-section-slider").length > 0) {
    $(".js-ugc-section-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#FFA51E" stroke="#FFA51E"/><path d="M23 15.5L17 21.5L23 27.5" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#FFA51E" stroke="#FFA51E"/><path d="M18 26.5L24 20.5L18 14.5" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // UGC lp Slider Start Here

  // PDP slider start here
  let petMatsProductCusNavSlider = $(
    ".js-pet-mats-product-details-main-slider"
  );
  let petMatsProductCusThumbSlider = $(
    ".js-pet-mats-product-details-nav-slider"
  );

  if (
    petMatsProductCusNavSlider.length > 0 &&
    !petMatsProductCusNavSlider.hasClass("slick-initialized") &&
    petMatsProductCusThumbSlider.length > 0 &&
    !petMatsProductCusThumbSlider.hasClass("slick-initialized")
  ) {
    petMatsProductCusNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      asNavFor: ".js-pet-mats-product-details-nav-slider",
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide">' +
        '<svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21.1992" r="20" transform="rotate(-180 20.5 21.1992)" fill="#FFA51E" stroke="#FFA51E"/><path d="M23 15.6992L17 21.6992L23 27.6992" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</button>",
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide">' +
        '<svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21.1992" r="20" fill="#FFA51E" stroke="#FFA51E"/><path d="M18 26.6992L24 20.6992L18 14.6992" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</button>",
    });

    petMatsProductCusThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".js-pet-mats-product-details-main-slider", // corrected selector
      arrows: true,
      dots: false,
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });
  }
  // PDP slider end here

  // Set countdown duration in seconds (e.g. 3 hours 39 minutes = 3*3600 + 39*60)
  let countdownSeconds = (4 * 3600);

  function updateCountdown() {
    if (countdownSeconds <= 0) {
      $('#countdown').text("0h:0m:0s");
      return;
    }

    let hours = Math.floor(countdownSeconds / 3600);
    let minutes = Math.floor((countdownSeconds % 3600) / 60);
    let seconds = countdownSeconds % 60;

    $('#countdown').text(`${hours}h:${minutes}m:${seconds}s`);

    countdownSeconds--;
  }

  // Initial update
  updateCountdown();

  // Update every second
  setInterval(updateCountdown, 1000);

  /* Guarded 19-Aug-2026: this ran unconditionally, and `.js-grid-layout` is
     rendered only by sections/eq-pt-loved-by-pets.liquid (the pet-mats LP).
     Calling a jQuery plugin on an empty set is a no-op while the plugin is
     loaded and a TypeError once it is not — and Masonry now loads only on that
     LP's layout. Same bug class as the mixitup/imagesLoaded guards in
     app.js.liquid. */
  var $gridLayout = $(".js-grid-layout");
  if ($gridLayout.length && typeof $gridLayout.masonry === "function") {
    $gridLayout.masonry({
      itemSelector: ".grid-item",
      columnWidth: ".grid-sizer",
      percentPosition: true,
      gutter: 24,
    });
  }

  function runMobileScript() {
    if (window.innerWidth <= 768) {
      $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item")
        .hide()
        .slice(0, 3)
        .show();

      $("#seeMore")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item:hidden")
            .slice(0, 3)
            .fadeIn("slow");

          if (
            $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item:hidden")
              .length === 0
          ) {
            $("#seeMore").fadeOut("slow");
          }
        });
    } else {
      // Optionally show all items and show/hide See More on larger screens
      $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item").show();
      $("#seeMore").hide();
    }
  }

  runMobileScript();

  // Run on resize
  $(window).resize(function () {
    runMobileScript();
  });

  $(".accordion__header").click(function (e) {
    // Close all open contents
    $(this).parent().siblings().removeClass("active");
    $(this).parent().toggleClass("active");
    $(".accordion__content").slideUp();
    // Toggle the current section
    const content = $(this).next(".accordion__content");
    if (!content.is(":visible")) {
      content.slideDown();
    }
  });
  if ($(".readmore__text").length > 0) {
    $("body").on("click", ".readmore__text", function (e) {
      e.preventDefault();

      const $content = $(this).parent().find(".description__content");
      const contentHeight = $content.get(0).scrollHeight; // Full content height
      const currentHeight = $content.height(); // Current height of the content

      const contentPosition = $content.offset().top; // Position of the content block relative to the page

      if (currentHeight < contentHeight) {
        // If content is collapsed, animate to show full content
        $content.stop().animate({ height: contentHeight }, 500);

        $("html, body").animate(
          {
            scrollTop: contentPosition,
          },
          500
        );

        $(this).text("Read Less");
      } else {
        $content.stop().animate({ height: 100 }, 500);

        // Simultaneously scroll the page up to the content position
        $("html, body").animate(
          {
            scrollTop: contentPosition - 100,
          },
          500
        );

        $(this).text("Read More");
      }
    });

    $(".description__content").stop().animate({ height: 100 }, 500);
  }

  $(document).on("click", ".play-pause-icon-wrap", function () {
    let clickedVideo = $(this)
      .parents(".ugc-section__box")
      .find(".ugc-video")
      .get(0);
    $(".ugc-video")
      .not(clickedVideo)
      .each(function () {
        this.pause(),
          $(this).siblings(".play-pause-icon-wrap").find(".icon-play").show(),
          $(this).siblings(".play-pause-icon-wrap").find(".icon-pause").hide();
      }),
      clickedVideo.paused
        ? (clickedVideo.play(),
          (clickedVideo.muted = !1),
          $(this).find(".icon-play").hide(),
          $(this).find(".icon-pause").show(),
          $(this).parents(".video-wrap").find(".icon-mute").hide(),
          $(this).parents(".video-wrap").find(".icon-unmute").show())
        : (clickedVideo.pause(),
          $(this).find(".icon-pause").hide(),
          $(this).find(".icon-play").show());
  }),
    $(document).on("click", ".mute-unmute-icon-wrap", function () {
      var clickedVideo = $(this)
        .parents(".ugc-section__box")
        .find(".ugc-video")
        .get(0);
      clickedVideo.muted
        ? (console.log("Unmute"),
          (clickedVideo.muted = !1),
          $(this).find(".icon-mute").hide(),
          $(this).find(".icon-unmute").show())
        : (console.log("Mute"),
          (clickedVideo.muted = !0),
          $(this).find(".icon-unmute").hide(),
          $(this).find(".icon-mute").show());
    });
});



function galleryBlogFilterDataMatchHeight() {
  let blogListFilters = [];

  if ($(".eq-blog-list__box").length > 0) {
    $(".eq-blog-list__box").each(function () {
      let filterValue = $(this).data("filter");
      // console.log('filterValue : ', filterValue);;

      if (!blogListFilters.includes(filterValue)) {
        //    console.log(`blogListFilters : ${blogListFilters} - filterValue : ${filterValue}`);
        blogListFilters.push(filterValue);
        //    console.log(`blogListFilters : ${blogListFilters}`);
      }
    });
  }

  if (blogListFilters) {
    blogListFilters.forEach(function (filter) {
      //  console.log("filter : ", filter);

      let filterBoxes = $(
        '.eq-blog-list__box[data-filter="' +
          filter +
          '"] .eq-blog-list__box-desc'
      );

      //  console.log(`class check ${$('.eq-blog-list__filter-content').first().attr('class')}`);
      //  console.log(`child length ${$('.eq-blog-list__filter-content').first().find('.eq-blog-list__box[data-filter="' + filter + '"]')}`);

      if (filterBoxes.find("h2").length > 0) {
        filterBoxes.find("h2").matchHeight({
          byRow: true,
        });
      }

      if (filterBoxes.find(".text-desc").length > 0) {
        filterBoxes.find(".text-desc").matchHeight({
          byRow: true,
        });
      }
    });
  }
}
// Blog Gallery Filter
$(".js-gallery-filter-button").on("click", function () {
 
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");
 
    // Hide all and show only the selected filter
    $(".eq-blog-list__boxx").addClass("is-hidden");
    // $('.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]').removeClass(
    //   "is-hidden"
    // );
    $('.eq-blog-list__boxx').filter(function () {
  let tags = $(this).data("tag-filter").toString().toLowerCase();
  return tags.split(',').map(t => t.trim()).includes(dataFilter.toLowerCase());
}).removeClass("is-hidden");


    // Hide button if no matching content
    if (
      $('.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]').length === 0
    ) {
      //    console.log("Filter Length : ", $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length);
      // $(this).hide();
    }

    let filterParent = $(
      '.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]'
    ).parent(".eq-blog-list__filter-content");
    if (!filterParent.hasClass("blog-filter-content-active")) {
      filterParent.addClass("blog-filter-content-active");
    }
    filterParent.siblings(".eq-blog-list__filter-content").each(function () {
      if ($(this).hasClass("blog-filter-content-active")) {
        $(this).removeClass("blog-filter-content-active");
      }
    });

    galleryBlogFilterDataMatchHeight();
  });
$(".js-gallery-filter-button--all").on("click", function(){
  $('.eq-blog-list__boxx').removeClass('is-hidden');
})
  $(document).ready(function () {

            $('.js-additional-pdp-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });
            // $('.js-first--button').trigger('click')
  });

//   document.addEventListener('input', function(e) {
//   if (e.target.classList.contains('width_cal_150') || e.target.classList.contains('length_cal_150')) {
//     e.target.value = e.target.value.replace(/[^0-9]/g, '');
//   }
// });

// function allowOnlyNumbers(selector) {
//   document.querySelectorAll(selector).forEach(input => {
//     input.addEventListener('input', () => {
//       input.value = input.value.replace(/[^0-9]/g, '');
//     });
//   });
// }

// // Apply to both
// allowOnlyNumbers('.width_cal_150');
// allowOnlyNumbers('.length_cal_150');
// allowOnlyNumbers('.custom-width__value');
// allowOnlyNumbers('.custom-length__value');
// allowOnlyNumbers('#fourplusqty');

function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  
  // Allow only digits (0–9)
  if (charCode >= 48 && charCode <= 57) {
    return true;
  }

  // Block everything else (including . and ,)
  return false;
}

$(document).on('click', '.mat-view-more-swatch', function() {
	$(this).find('.main-product__swatch-text').html(`Show Less <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.963906 5.26H11.0439V6.62H0.963906V5.26Z" fill="#222329"/>
</svg>`);
	$(this).removeClass('mat-view-more-swatch');
	$(this).addClass('mat-view-less-swatch');
  $('.extra_color_text').show();
	$(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').show();
});
$(document).on('click', '.mat-view-less-swatch', function() {
	$(this).find('.main-product__swatch-text').html(`Show more <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.68391 5.26H11.0439V6.62H6.68391V11H5.32391V6.62H0.963906V5.26H5.32391V0.879999H6.68391V5.26Z" fill="#222329" /></svg>`);
	$(this).removeClass('mat-view-less-swatch');
	$(this).addClass('mat-view-more-swatch');
  $('.extra_color_text').hide();
	$(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').hide();
});
document.querySelectorAll('input[name="background-color-swatch"]').forEach(swatch => {
	swatch.addEventListener('change', (e) => {
		boxColor = e.target.value;
		let selectedColorName = e.target.getAttribute('data-color-name');
		// Update only the inner spans — setting `.textContent` on the
		// `<p class="main-product__selected-color">` parent wiped out
		// the `<span class="main-product__selected-color-text">` (which
		// carries the "Selected:" prefix and the bold-style class) and
		// the sibling swatch span, leaving plain unstyled text.
		const selectedTextEl = document.querySelector('.main-product__selected-color-text');
		const selectedSwatchEl = document.querySelector('.main-product__selected-color-swatch');
		if (selectedTextEl) {
			selectedTextEl.textContent = 'Selected: ' + selectedColorName;
		}
		if (selectedSwatchEl && e.target.value) {
			selectedSwatchEl.style.backgroundColor = e.target.value;
		}
		// borderColor = e.target.value;
		updatePreview();
	});
});

$(document).ready(function () {
  $(".js_show-more").html(`Show more <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.68391 5.26H11.0439V6.62H6.68391V11H5.32391V6.62H0.963906V5.26H5.32391V0.879999H6.68391V5.26Z" fill="#222329" /></svg>`);
});




  let customerReviewSlider = $('.js-cient-review-slider');

  if(customerReviewSlider.length > 0 ){
    customerReviewSlider.each(function () {
      let currentCustomerReviewSlider = $(this);

      if (!currentCustomerReviewSlider.hasClass('slick-initialized')) {
        currentCustomerReviewSlider.slick({
          arrows: true,
          infinite: false,
          loop: false,
          variableWidth: true,
          autoplay: true,
          autoplaySpeed: 4000,
          draggable: true,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-tab'), 10),
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-mobile'), 10),
              }
            }
          ]
      });
      }

    });
  }